<template>
  <div
    class="
      p-6
      mx-auto
      max-w-4xl
      fixed
      top-40
      left-72
      right-0
      z-50
      overflow-hidden
      card
      shadow-2xl
      bg-base-100
      modal-box
      mb-4
      bg-gradient-to-bl
      from-blue-400
      to-blue-200
    "
  >
    <div class="card-body relative">
      <div
        @click="closeView"
        class="
          cursor-pointer
          absolute
          top-0
          right-0
          mr-10
          transform
          translate-x-9
          -translate-y-2
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <div class="grid grid-cols-3 gap-3">
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >Job Title</span
            >
          </label>
          <div class="flex items-center">
            <input
              :value="data[i].jobTitle"
              type="text"
              class="
                input input-bordered
                w-full
                border-theme-green
                focusring
                input-sm
              "
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >No of Posts</span
            >
          </label>
          <div class="flex items-center">
            <input
              :value="data[i].noOfPosts"
              type="text"
              class="
                input input-bordered
                w-full
                border-theme-green
                focusring
                input-sm
              "
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >Qualifications</span
            >
          </label>
          <div class="relative flex items-center">
            <div class="absolute border-r-2 border-blue-400 py-1 px-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6 text-theme-black"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
                />
              </svg>
            </div>

            <select class="select select-bordered w-full pl-12 select-sm">
              <option>{{ data[i].qual }}</option>
              <option>{{ data[i].qual1 }}</option>
              <option>{{ data[i].qual2 }}</option>
            </select>
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >Approximate Salary</span
            >
          </label>
          <div class="flex items-center">
            <input
              :value="data[i].appSalary"
              type="text"
              class="
                input input-bordered
                w-full
                border-theme-green
                focusring
                input-sm
              "
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >Approximate Experience</span
            >
          </label>
          <div class="flex items-center">
            <input
              :value="data[i].appExp"
              type="text"
              class="
                input input-bordered
                w-full
                border-theme-green
                focusring
                input-sm
              "
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >Package Type</span
            >
          </label>
          <div class="flex items-center">
            <input
              :value="data[i].packageType"
              type="text"
              class="
                input input-bordered
                w-full
                border-theme-green
                focusring
                input-sm
              "
            />
          </div>
        </div>
        <div class="form-control">
          <label class="label">
            <span
              class="
                label-text
                font-bold
                tracking-tight
                leading-tight
                text-white
              "
              >Package Fee</span
            >
          </label>
          <div class="flex items-center">
            <input
              :value="data[i].fees"
              type="text"
              class="
                input input-bordered
                w-full
                border-theme-green
                focusring
                input-sm
              "
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mill Data View",
  props: ["data", "closeView", "i"],
};
</script>

<style>
</style>